// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum ModelsMutationTypes {
    SET_MODELS = 'SET_MODELS',
    SET_MODEL_LOADED = 'SET_MODEL_LOADED',
  }
  